<template>
  <div id="reservation-create-page">
    <vue-persian-calender
      :events-list="events"
      date-format="YYYY-MM-DDTHH:mm:ss.SSSZ"
      @on-event-click="onReserveClick"
    ></vue-persian-calender>
  </div>
</template>

<script>
import VuePersianCalender from 'vue-persian-calendar'
import moduleReserve from '@/store/reserve/moduleReserve.js'

export default {
  name: 'ReservationSelect',
  components: {
    VuePersianCalender
  },
  data() {
    return {
      events: []
    }
  },
  methods: {
    onReserveClick(e) {
      this.$store.dispatch('request/fetchHealthRequestById', e.id).then(res => {
        this.$router.push({ name: 'employee-invoice-view', params: { id: res.data.invoiceId } })
      })
    }
  },
  created() {
    this.$vs.loading()
    if (!moduleReserve.isRegistered) {
      this.$store.registerModule('reserve', moduleReserve)
      moduleReserve.isRegistered = true
    }
    this.$store.commit('reserve/SET_QUERY', { owner: this.$store.state.AppActiveUser.id })
    this.$store.commit('reserve/SET_LIMIT', 1000)
    this.$store
      .dispatch('reserve/fetchReserves')
      .then(res => {
        this.events = res.data.map(i => ({
          id: i.requestId.split('@')[1],
          title: this.$t('reservation.reserved'),
          startDateTime: this.$moment(i.startDate),
          endDateTime: this.$moment(i.endDate)
        }))
      })
      .finally(() => {
        this.$vs.loading.close()
      })
  }
}
</script>

<style lang="scss">
#reservation-create-page {
  .vpc_day:not(.vpc_past),
  .vpc_event {
    cursor: pointer !important;
  }
}
</style>
